import {createContext, Context} from 'solid-js'
import {IntlShape} from '@formatjs/intl'

export const i18nProviderContext: Context<IntlShape | undefined> = createContext()
